/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
import { redirectURI } from 'constants/index';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: '2440f7d0-b789-4ed3-91d9-ba94861b65a8',
    authority: 'https://login.microsoftonline.com/common',
    // redirectUri: 'http://localhost:3000/',
    redirectUri: `${redirectURI}`,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii): any => {
        if (containsPii) {
          return console.log('contains Pii');
        }
        switch (level) {
          case LogLevel.Error:
            return console.error(message);

          case LogLevel.Info:
            return console.info(message);

          case LogLevel.Verbose:
            return console.debug(message);

          case LogLevel.Warning:
            return console.warn(message);

          default:
            return console.log('Nothing to return');
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
//  fc795d42-8a7c-4850-b1fe-55ee6c53f1a3

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphRooms: 'https://graph.microsoft.com/v1.0/places/microsoft.graph.room',
  roomsCalendar: 'https://graph.microsoft.com/v1.0/me/calendar/events',
};
